<template>
  <div class="orders-report">
    <wrld-container :breadcrumbs="this.breadcrumbs" isFluid>
      <AlgoliaSearchWrapper
        :indexName="indexName"
        :forRoute="$router.currentRoute.name"
      >
        <wrld-out-of-box :title="$tc('orders.orders', 2) +' - ' + this.$i18n.tc('menu.reports', 1)">
          <template v-slot:headerBtns>
            <AlgoliaRefresh />
          </template>
        </wrld-out-of-box>
        <v-row>
          <v-col class="pr-4" md="3" v-sticky="{ zIndex: 1, stickyTop: 80, disabled: false}">
            <ReportOrdersFilters />
          </v-col>
          <v-col md="9">
            <OrdersCharts :indexName="indexName"/>
          </v-col>
        </v-row>
      </AlgoliaSearchWrapper>
    </wrld-container>
  </div>
</template>

<script>
import ReportOrdersFilters from '@/components/reports/orders/ReportOrdersFilters'
import AlgoliaSearchWrapper from '@/components/general/AlgoliaSearchWrapper'
import OrdersCharts from '@/components/reports/orders/OrdersCharts'
import AlgoliaRefresh from '@/components/general/AlgoliaRefresh'

export default {
  name: 'OrdersReport',
  components: {
    AlgoliaSearchWrapper,
    AlgoliaRefresh,
    ReportOrdersFilters,
    OrdersCharts
  },
  data () {
    return {
      indexName: 'prod_orders',
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('orders.orders') + ' - ' + this.$i18n.tc('menu.reports', 1), disabled: true }
      ]
    }
  }
}
</script>
